export const RLP_ATTRIBUTION = Object.freeze({
  text: "Match data courtesy of the Rugby League Project",
  href: "https://www.rugbyleagueproject.org/",
});
